module.exports = __webpack_public_path__ + "static/media/user_icon_yl.dd03d5df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user_icon_yl.svg
// module id = 111
// module chunks = 0